/* Lightweight, progressively enhanced editorial accordions; no purchase logic here. */
(() => {
  document.addEventListener('click', e => {
    const link = e.target.closest('header-drawer a[href]');
    if (!link) return;
    const destination = new URL(link.href, location.href);
    if (destination.origin === location.origin && destination.pathname === location.pathname && destination.hash) {
      const drawer = link.closest('header-drawer');
      const details = drawer?.querySelector('details');
      if (details?.open) drawer.closeMenuDrawer?.(e, details.querySelector('summary'));
    }
  });
  const init = (root = document) => {
    root.querySelectorAll('[data-kr5-moments], .kr5-step-list').forEach(group => {
      if (group.dataset.kr5Ready) return;
      group.dataset.kr5Ready = 'true';
      const items = [...group.querySelectorAll('details')];
      items.forEach(item => item.addEventListener('toggle', () => {
        if (item.open) items.forEach(other => { if (other !== item) other.open = false; });
      }));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once: true});
  else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();

// Scoped to the two supplied routine examples; existing UGC controls are unchanged.
document.addEventListener('play', event => {
  if (!event.target.matches?.('.kr6-routine-player video')) return;
  document.querySelectorAll('.kr6-routine-player video').forEach(video => {
    if (video !== event.target) video.pause();
  });
}, true);
